<template>
	<div>
		<div @click="handleClick" class="circle" :style="style" v-if="realtimeData.state === true && mode === 'view'">
			<div class="text">{{text}}</div>
		</div>
		<div :style="style" v-if="mode === 'edit'">
			<div class="text">{{text}}</div>
		</div>
    <el-dialog :style="dialogStyle"
        title="子窗口页面"
        :visible.sync="modalShow"
        :width="realtimeData.modalValue+'px'"
        @close="modalShow=false"
        append-to-body>
      <div :style="modelStyle">
        <div style="width: 100%; ">
          <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
        </div>
      </div>
    </el-dialog>
	</div>
</template>

<script>
import componentsMixin from "../componentsMixin";

export default {
	name: "circleComponent",
  mixins: [componentsMixin],
	data(){
		return{
			colorFlag: 0,
		}
	},
	methods:{
		//圆形闪烁
		flashCircle(){
			this._style["animation-play-state"] = 'running'
			this.settings.flash = true
			this.newSettings.flash = true
		},
		//取消闪烁
		stopFlashCircle(){
			this._style["animation-play-state"] = 'paused'
			this.settings.flash = false
			this.newSettings.flash = false
		},
		//圆形消失
		disappearCircle(){
			// if(this.settings.state == true){
			// 	this._style["background-color"] = 'transparent'
			// 	this._style["border-color"] = 'transparent'
			// 	this.settings.state = false
			// }
			// this.newSettings.state = false
			this.settings.state = false
		},
		//圆形出现
		appearCircle(){
			// if(this.settings.state == false){
			// 	this._style["background-color"] = this.settings.circleColor
			// 	this._style["border-color"] = this.settings.borderColor 
			// 	this.settings.state = true
			// }
			// this.newSettings.state = true
			this.settings.state = true
		}
	},
	computed: {
		text() {
			return this.dynamicProps.dynamicText
		},
    dialogStyle(){
      if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
        var applyLeft = '0'
        var applyTop = '0'
      } else if (this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = '0'
        var applyTop = '0'
      }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
        var applyLeft = this.realtimeData.modalX
        var applyTop = '0'
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
        var applyLeft = '0'
        var applyTop = this.realtimeData.modalY
      } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
        var applyLeft = this.realtimeData.modalX
        var applyTop = this.realtimeData.modalY
      }
      return {
        top:`calc(${applyTop}px + 10vh)`,
        left: applyLeft + 'px',
      }
    },
	},
	watch: {
    // 'realtimeData.top': {  // x绑定
    //   handler() {
    //     this.wrapperStyle.top = this.realtimeData.top +'px'
    //   }
    // },
    // 'realtimeData.left': {  // y绑定
    //   handler() {
    //     this.wrapperStyle.left = this.realtimeData.left +'px'
    //   }
    // },
    // 'realtimeData.height': {  // 高度绑定
    //   handler() {
    //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
    //     this.wrapperStyle.height = this.realtimeData.height +'px'
    //   }
    // },
    // 'realtimeData.width': {  // 宽度绑定
    //   handler() {
    //     console.log("宽度发生改变",this.realtimeData.width,this.style)
    //     this._style.width = this.realtimeData.width + 'px'
    //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
    //   }
    // },
		'realtimeData.circleColor': {  // 颜色绑定
			handler() {
				this._style["background-color"] = this.realtimeData.circleColor
			}
		},
		"realtimeData.borderColor": { //边框颜色
			handler() {
				this._style["border-color"] = this.realtimeData.borderColor
			}
		},
		'realtimeData.borderWidth':{ //边框粗细
			handler(){
				this._style["border-width"] = this.realtimeData.borderWidth + 'px'
			}
		},
		'realtimeData.borderStyle':{ //边框样式
			handler(){
				this._style["border-style"] = this.realtimeData.borderStyle
			}
		},
	}
}
</script>

<style lang="less" scoped>
	@keyframes twinkle {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
		100% {
			opacity: 1;
		}
	}
	
	.circle{
		animation-name: twinkle;
		animation-timing-function: ease-in-out;
		animation-iteration-count:infinite;
	}
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>
